import { getMaskedString } from './get-masked-string';
var WHITE_LIST = ['x-supplier-id'];
export var getFilteredCookies = function (pureCookies) {
    return pureCookies.replace(/([\w-_.]*)=([\w-_.]*)(;)?/g, function (match, p1, p2, p3) {
        if (p3 === void 0) { p3 = ''; }
        if (WHITE_LIST.includes(p1)) {
            return p1 + "=" + p2 + p3;
        }
        var maskedString = getMaskedString(p2);
        return p1 + "=" + maskedString + p3;
    });
};
